import React from 'react';
import { EsenciaAurica } from './pages/EsenciaAurica';
export function App() {
  return <div className="min-h-screen" data-id="element-0" data-mp="35ckao89f74ji">
      <EsenciaAurica data-id="element-1" data-mp="35binj5f4qrlf" />
    </div>;
}